module.exports = __webpack_public_path__ + "img/edit-network-dashboard.3f54f18f.png";